import { render, staticRenderFns } from "./ApprovedStartupList.vue?vue&type=template&id=bbca46de"
import script from "./ApprovedStartupList.vue?vue&type=script&lang=js"
export * from "./ApprovedStartupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports